import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/cards-with-tooltip");
import("../src/javascripts/tabs");
import("../src/javascripts/slider_splide");
import("../src/javascripts/smooth-scroll-to-anchor");
import("../src/javascripts/cards-with-tooltip");
